module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-white-on-red-a19cb4a7085f3efd804b01f2622413cd.png";